import React, { useState, useMemo } from 'react';
import './Style/AllUsers.css';
import useUsersData from './../Auth/AllUsers';
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';

const toIST = (dateString) => {
    if (!dateString) return 'Loading...';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleString('en-IN', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
};

const AllUsers = () => {
    const { users, loading } = useUsersData();

    const [searchTerm, setSearchTerm] = useState('');
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);

    // IMPORTANT:
    // Hook must be before the loading return
    const filteredUsers = useMemo(() => {
        if (!users) return [];

        const search = searchTerm.toLowerCase().trim();

        if (!search) {
            return users;
        }

        return users.filter((user) => {
            return [
                user.name,
                user.class,
                user.phone,
                user.email,
                user.registar_date,
                user.last_login,
                user.id,
                user.first_login_id,
                user.second_login_id
            ]
                .filter(
                    value =>
                        value !== null &&
                        value !== undefined
                )
                .some(value =>
                    String(value)
                        .toLowerCase()
                        .includes(search)
                );
        });
    }, [users, searchTerm]);

    // Now loading check is safe
    if (loading) {
        return <Loading />;
    }

    const totalPages =
        itemsPerPage === 'all'
            ? 1
            : Math.ceil(
                filteredUsers.length /
                Number(itemsPerPage)
            );

    const startIndex =
        itemsPerPage === 'all'
            ? 0
            : (currentPage - 1) *
            Number(itemsPerPage);

    const displayedUsers =
        itemsPerPage === 'all'
            ? filteredUsers
            : filteredUsers.slice(
                startIndex,
                startIndex + Number(itemsPerPage)
            );

    const handleSearch = (e) => {
        setSearchTerm(e.target.value);
        setCurrentPage(1);
    };

    const handleItemsPerPage = (e) => {
        setItemsPerPage(e.target.value);
        setCurrentPage(1);
    };

    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="all-user-data-container">

            <div className="user-data-content-wrapper">


                <div className="user-data-card">

                    <h2 style={{ color: 'black' }}>
                        All Users Information
                    </h2>

                    {/* Search + Show items */}

                    <div className="user-table-controls">

                        <div className="user-search-box">

                            <input
                                type="text"
                                placeholder="Search name, class, phone, email, ID..."
                                value={searchTerm}
                                onChange={handleSearch}
                            />

                            {searchTerm && (
                                <button
                                    type="button"
                                    className="clear-search-btn"
                                    onClick={() => {
                                        setSearchTerm('');
                                        setCurrentPage(1);
                                    }}
                                >
                                    ×
                                </button>
                            )}

                        </div>

                        <div className="items-per-page">

                            <label htmlFor="itemsPerPage">
                                Show:
                            </label>

                            <select
                                id="itemsPerPage"
                                value={itemsPerPage}
                                onChange={handleItemsPerPage}
                            >
                                <option value="10">
                                    10
                                </option>

                                <option value="25">
                                    25
                                </option>

                                <option value="50">
                                    50
                                </option>

                                <option value="100">
                                    100
                                </option>

                                <option value="all">
                                    All
                                </option>
                            </select>

                            <span>items</span>

                        </div>

                    </div>

                    {/* Statistics */}

                    <div className="user-data-stats">

                        <p>
                            Total Users:{' '}
                            <strong>
                                {users ? users.length : 0}
                            </strong>
                        </p>

                        <p>
                            Search Result:{' '}
                            <strong>
                                {filteredUsers.length}
                            </strong>
                        </p>

                    </div>

                    {/* Table */}

                    <div className="table-responsive">

                        <table className="user-data-table">

                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Name</th>
                                    <th>Class</th>
                                    <th>Phone</th>
                                    <th>Email</th>
                                    <th>Register Date</th>
                                    <th>Last Login</th>
                                    <th>User ID</th>
                                    <th>First Login ID</th>
                                    <th>Second Login ID</th>
                                </tr>
                            </thead>

                            <tbody>

                                {displayedUsers.length > 0 ? (

                                    displayedUsers.map(
                                        (user, index) => (

                                            <tr
                                                key={
                                                    user.id ||
                                                    index
                                                }
                                            >

                                                <td>
                                                    {startIndex +
                                                        index +
                                                        1}
                                                </td>

                                                <td>
                                                    {user.name ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {user.class ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {user.phone ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {user.email ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {toIST(user.registar_date) ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {toIST(user.last_login) ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {user.id ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {user.first_login_id ||
                                                        'N/A'}
                                                </td>

                                                <td>
                                                    {user.second_login_id ||
                                                        'N/A'}
                                                </td>

                                            </tr>
                                        )
                                    )

                                ) : (

                                    <tr>
                                        <td
                                            colSpan="10"
                                            className="no-data-message"
                                        >
                                            {searchTerm
                                                ? 'No users found for this search'
                                                : 'No users found'}
                                        </td>
                                    </tr>

                                )}

                            </tbody>

                        </table>

                    </div>

                    {/* Pagination */}

                    {itemsPerPage !== 'all' &&
                        filteredUsers.length > 0 && (

                            <div className="user-pagination">

                                <button
                                    onClick={() =>
                                        goToPage(
                                            currentPage - 1
                                        )
                                    }
                                    disabled={
                                        currentPage === 1
                                    }
                                >
                                    ← Previous
                                </button>

                                <span>
                                    Page{' '}
                                    <strong>
                                        {currentPage}
                                    </strong>
                                    {' '}of{' '}
                                    <strong>
                                        {totalPages}
                                    </strong>
                                </span>

                                <button
                                    onClick={() =>
                                        goToPage(
                                            currentPage + 1
                                        )
                                    }
                                    disabled={
                                        currentPage ===
                                        totalPages
                                    }
                                >
                                    Next →
                                </button>

                            </div>

                        )}

                    {/* Bottom information */}

                    <div className="user-data-stats">

                        <p>
                            Showing{' '}
                            <strong>
                                {filteredUsers.length === 0
                                    ? 0
                                    : startIndex + 1}
                            </strong>
                            {' '}to{' '}
                            <strong>
                                {Math.min(
                                    startIndex +
                                    displayedUsers.length,
                                    filteredUsers.length
                                )}
                            </strong>
                            {' '}of{' '}
                            <strong>
                                {filteredUsers.length}
                            </strong>
                            {' '}users
                        </p>

                    </div>

                </div>

            </div>

        </div>
    );
};

export default AllUsers;